/**
 * Registrar Api
 * The registrar api
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EncounterDetailsFieldModel } from './encounterDetailsFieldModel';

export interface EncounterDetailsGroupModel {
    title: string;
    status: EncounterDetailsGroupModel.StatusEnum;
    action: string;
    actionLabel: string;
    payload: any;
    details: EncounterDetailsFieldModel;
    fields: Array<EncounterDetailsFieldModel>;
}
export namespace EncounterDetailsGroupModel {
    export type StatusEnum = 'COMPLETE' | 'INCOMPLETE' | 'WARNING';
    export const StatusEnum = {
        COMPLETE: 'COMPLETE' as StatusEnum,
        INCOMPLETE: 'INCOMPLETE' as StatusEnum,
        WARNING: 'WARNING' as StatusEnum,
    };
}
